import config from '../../config'
import fetch from '../../lib/wrappedFetch'
import variantsStockService from '../../services/variantsStockService'

class VariantsStockController {
  fetchVariantStoreStocks = variantsStockService.fetchVariantStoreStocks
}

export default new VariantsStockController()
 


// WEBPACK FOOTER //
// ../src/controllers/variantsStockController/variantsStockController.js